import * as React from 'react';

import {LinkPreload} from './LinkPreload';
import {LinkTarget} from './LinkTarget';
import type {State, ChangeTypes} from './LinkTypes';
import {LinkPageSelectorRender} from '../LinkPageSelectorType';
import {Label} from './LinkUIComponents';

export const usePageId = (state: State, dispatch: (arg1?: any) => void) => {
  const [pageId, setPageId] = React.useState(state.pageId);

  const onChange = React.useCallback(
    (
      newPageId: string | null | undefined,
      {
        changeType,
      }: {
        changeType: ChangeTypes;
      }
    ) => {
      if (changeType === 'changeEnd') {
        // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'SetStateAction<string | undefined>'.
        setPageId(newPageId);
        dispatch({
          payload: {...state, pageId: newPageId},
          meta: {
            analytics: {
              type: 'element-settings-updated',
              value: 'static page',
            },
          },
        });
      }
    },
    [dispatch, state]
  );

  React.useEffect(() => {
    // When switching modes, we reset to undefined so we can show the placeholder.
    if (!state.pageId) {
      setPageId(undefined);
    } else if (state.pageId && pageId !== state.pageId) {
      setPageId(state.pageId);
    }
  }, [onChange, state.pageId, pageId]);

  return {onChange, pageId};
};

export const LinkPageMode = ({
  state,
  dispatch,
  isOverride,
}: {
  state: State;
  dispatch: (arg1?: any) => void;
  isOverride: boolean;
}) => {
  const {pageId, onChange} = usePageId(state, dispatch);

  return (
    <>
      {/* Page */}
      <Label
        data-automation-id="symbols-dataType-contentType"
        isOverride={isOverride}
      >
        Page
      </Label>
      <LinkPageSelectorRender pageId={pageId} onChange={onChange} />
      {/* Target */}
      <Label
        data-automation-id="symbols-dataType-contentType"
        isOverride={isOverride}
      >
        Open in
      </Label>
      <LinkTarget state={state} dispatch={dispatch} />
      {/* Preload */}
      <Label
        data-automation-id="symbols-dataType-contentType"
        isOverride={isOverride}
      >
        Preload
      </Label>
      <LinkPreload state={state} dispatch={dispatch} />
    </>
  );
};
